import { MicroMClient, StatusValues } from "@mcurros2/microm";
import { IconStatusChange } from "@tabler/icons-react";

export const AutorizacionDirectaIcon = IconStatusChange;
export const AutorizacionDirectaHelpText = "* Valores para estado Autorizacion Directa";

export class estAutorizacionDirecta extends StatusValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_status_id.value = "AutorizacionDirecta";
        this.def.columns.c_status_id.defaultValue = "AutorizacionDirecta";
        this.Title = "Estado Autorizacion Directa";
        this.HelpText = AutorizacionDirectaHelpText;
        this.Icon = AutorizacionDirectaIcon;
    }
}